export default "__VITE_ASSET__BcDP2z5Z__"